export default __webpack_public_path__ + "static/media/car.fa4b3e8f.png";